import { Controller } from '@hotwired/stimulus'
import { GRID_EVENTS } from './grid_events'

// The header "Review" button: toggles the review sidebar and keeps its badge in step with the count the
// rail broadcasts on each reload.
export default class extends Controller {
  static targets = ['badge']

  connect() {
    this.onCounts = event => this.updateBadge(event.detail.decisions)
    document.addEventListener(GRID_EVENTS.reviewCounts, this.onCounts)

    // Mirror the reporting-periods sidebar: hide this opener (the Review button) while the sidebar is
    // open, and show it again once it closes — the sidebar's own close control takes over from here.
    this.onSidebarOpen = () => this.element.classList.add('d-none')
    this.onSidebarClose = () => this.element.classList.remove('d-none')
    window.addEventListener('galette:sidebar:open', this.onSidebarOpen)
    window.addEventListener('galette:sidebar:close', this.onSidebarClose)
  }

  disconnect() {
    document.removeEventListener(GRID_EVENTS.reviewCounts, this.onCounts)
    window.removeEventListener('galette:sidebar:open', this.onSidebarOpen)
    window.removeEventListener('galette:sidebar:close', this.onSidebarClose)
  }

  toggle() {
    document.dispatchEvent(new CustomEvent('galette:sidebar:toggle'))
  }

  updateBadge(count) {
    if (!this.hasBadgeTarget || count == null) return

    this.badgeTarget.textContent = count
    this.badgeTarget.classList.toggle('d-none', count === 0)
  }
}
